export const isApple =
  typeof navigator !== 'undefined' &&
  navigator.platform.match(/^(Mac|iPhone|iPod|iPad)/);
